const state = {
  correctTamp: null
};

const mutations = {
  SET_CORRECT_TAMP: (state, correctTamp) => {
    state.correctTamp = correctTamp;
  }
};

const actions = {
  setCorrectTamp({ commit }, correctTamp) {
    commit("SET_CORRECT_TAMP", correctTamp);
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
